// extracted by mini-css-extract-plugin
module.exports = {"Root":"-qNBMLW8UzPERZSzrKqmGw=="};